import * as React from 'react';

import useSWR from 'swr';

import { useAppContext } from 'hooks/context/useAppContext';
import { usePreferences } from 'hooks/preferences/usePreferences';

import { TReview } from 'types/review';

import { getReviewsURL } from './helpers';

export const REVIEW_PAGINATION_INTERVAL = 5;

type ReviewsResponse = {
  data: TReview[];
};

export const useReviews = () => {
  const {
    config: { apiUrlV3 },
    publicUser: { slug },
  } = useAppContext();
  const url = getReviewsURL({
    apiUrlV3,
    slug,
  });

  const { showClientReviews } = usePreferences();

  const { isLoading, error, data } = useSWR<ReviewsResponse>(url);
  const reviews = data?.data || [];

  const [reviewCount, setReviewCount] = React.useState<number>(
    REVIEW_PAGINATION_INTERVAL,
  );

  const showMoreReviews = () =>
    setReviewCount(reviewCount + REVIEW_PAGINATION_INTERVAL);
  const visibleReviews = reviews.slice(0, reviewCount);
  const hasMoreReviews = reviewCount < reviews.length;

  const showReviews = showClientReviews && reviews?.length > 0;

  return {
    isLoading,
    error,
    reviews,
    showReviews,
    hasMoreReviews,
    visibleReviews,
    showMoreReviews,
  };
};
